import useTranslation from '~/hooks/useTranslation';
import formatDate from '~/helpers/formatDate';
import type { Summary as SummaryType } from '~/types/api';
import IconUser from '~icons/tabler/user';
import IconUsers from '~icons/tabler/users';
import IconCalendar from '~icons/tabler/calendar';
import IconBed from '~icons/tabler/bed';

type Props = {
  summary: SummaryType;
  className?: string;
};

export default function Summary({
  summary,
  className,
}: Props) {
  const translate = useTranslation();

  if (!summary) {
    return null;
  }

  return (
    <div className={className}>
      <h2>
        {translate('bookingFlow.sidebar.summary')}
      </h2>

      <div>
        {summary.title}
      </div>

      <div>
        {summary.pax > 1 ? <IconUsers /> : <IconUser />}
        {`${summary.pax} ${translate(summary.pax > 1 ? 'bookingFlow.sidebar.persons' : 'bookingFlow.sidebar.person')}`}
      </div>

      <div>
        <IconCalendar />
        {`${formatDate(summary.start_date)} – ${formatDate(summary.end_date)}`}
      </div>

      {summary.nights > 1 && (
        <div>
          <IconBed />
          {`${summary.nights} ${translate('bookingFlow.sidebar.nights')}`}
        </div>
      )}
    </div>
  );
}
